import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { CommonConstants } from 'src/app/shared/constant';

@Injectable({
  providedIn: 'root',
})
export class EncryptionService {
  constructor() {}

  set(value: any, keys: any = CommonConstants.passphrase) {
    var key = CryptoJS.enc.Utf8.parse(keys);
    var iv = CryptoJS.enc.Utf8.parse(keys);
    var encrypted = CryptoJS.AES.encrypt(
      CryptoJS.enc.Utf8.parse(value.toString()),
      key,
      {
        keySize: 128 / 8,
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }
    );
    return encrypted.toString();
  }

  get(value: any, keys: any = CommonConstants.passphrase) {
    var key = CryptoJS.enc.Utf8.parse(keys);
    var iv = CryptoJS.enc.Utf8.parse(keys);
    var decrypted = CryptoJS.AES.decrypt(value, key, {
      keySize: 128 / 8,
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    return decrypted.toString(CryptoJS.enc.Utf8);
  }

  setJson(value: any, keys: any = CommonConstants.passphrase) {
    return encodeURIComponent(
      CryptoJS.AES.encrypt(JSON.stringify(value), keys).toString()
    );
  }

  getJson(value: any, keys: any = CommonConstants.passphrase) {
    var data = CryptoJS.AES.decrypt(decodeURIComponent(value), keys);
    return JSON.parse(data.toString(CryptoJS.enc.Utf8));
  }
}
